import React, { FC } from 'react'
import classNames from 'classnames'
import { getStyledElementProps } from '../../../utils/helpers'

import { CheckboxProps } from '@/types'

import styles from './checkbox.module.scss'

export const Checkbox: FC<CheckboxProps> = ({
  name,
  multiple,
  checked,
  defaultChecked,
  onChange,
  onBlur,
  onClick,
  value = '',
  spanProps = {},
  inputProps = {},
  backgroundColor,
}) => {
  const styledSpanProps = getStyledElementProps(
    spanProps,
    classNames(styles['wrapper'], { [styles['wrapper--checked']]: checked })
  )
  const styledInputProps = getStyledElementProps(inputProps, styles['input'])
  const { className: styledSpanPropsClassName, ...spanRestProps } =
    styledSpanProps

  return (
    <span
      className={`${styledSpanPropsClassName} ${
        checked ? `${styles['wrapper--checked']}` : ''
      }`}
      {...spanRestProps}
      style={checked ? { color: backgroundColor } : {}}
    >
      <input
        type="checkbox"
        name={name}
        value={value}
        multiple={multiple}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={onChange}
        onBlur={onBlur}
        onClick={onClick}
        {...styledInputProps}
      />
      <svg
        className={styles['svg']}
        viewBox="3 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        {checked ? (
          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        ) : (
          <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
        )}
      </svg>
    </span>
  )
}
